export default __webpack_public_path__ + "static/media/undraw_joyride_hnno.f662547d.svg";